var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-processor"},[_c('md-button',{staticClass:"image-processor__button md-raised md-primary",on:{"click":_vm.processImages}},[_vm._v("Process Images")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }